export default "__VITE_ASSET__CJ9Zp_d0__"